import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { AppointmentDTO } from './dto/appointment.dto';


export class AppointmentResponseModel extends GlobalResponseObject {
    data?: any;
    response: AppointmentDTO[];
}
export class AllAppointmentResponseModel extends GlobalResponseObject{
    data?: any[];
}





